import { Trans, useTranslation } from 'react-i18next';

import { Alert, Anchor } from '@myphx-engineering/phx-design-system';

export interface PhoneExistsErrorProps {
    onLinkClick: () => void;
}

export const PhoneExistsError = (props: PhoneExistsErrorProps) => {
    const { onLinkClick } = props;
    const { t } = useTranslation('sso');

    return (
        <Alert data-testid="phone-exists-error" severity="error">
            <Trans
                t={t}
                i18nKey="formErrors.phoneExistsError.tryAnother"
                components={{ 1: <Anchor onClick={onLinkClick} /> }}
            />
        </Alert>
    );
};
